var UserTasksHelper = (function () {
    function UserTasksHelper($uibModal) {
        this.$uibModal = $uibModal;
    }
    UserTasksHelper.prototype.handleRepresentationChanges = function (unconfirmed, conflicts, empty, reminder) {
        var modal = this.$uibModal.open({
            template: "<modal-player-representation-changes modal-instance=\"$ctrl.modalInstance\" unconfirmed=\"$ctrl.unconfirmed\" conflicts=\"$ctrl.conflicts\" empty=\"$ctrl.empty\" reminder=\"$ctrl.reminder\">",
            controllerAs: '$ctrl',
            backdrop: 'static',
            keyboard: false,
            controller: [
                '$uibModalInstance',
                function ($uibModalInstance) {
                    this.modalInstance = $uibModalInstance;
                    this.unconfirmed = unconfirmed;
                    this.conflicts = conflicts;
                    this.empty = empty;
                    this.reminder = reminder;
                },
            ],
        });
        modal.result.catch(angular.noop);
    };
    UserTasksHelper.prototype.handleTOSUpdate = function (lastUpdated) {
        var modal = this.$uibModal.open({
            template: "<modal-accept-tos modal-instance=\"$ctrl.modalInstance\" tos-last-updated=\"$ctrl.lastUpdated\">",
            backdrop: 'static',
            keyboard: false,
            controllerAs: '$ctrl',
            controller: [
                '$uibModalInstance',
                function ($uibModalInstance) {
                    this.modalInstance = $uibModalInstance;
                    this.lastUpdated = lastUpdated;
                },
            ],
        });
        modal.result.catch(angular.noop);
    };
    return UserTasksHelper;
}());
angular.module('app.general').service('UserTasksHelper', UserTasksHelper);
;